import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { BaseSendToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendToPortalPopupStrategy";

class SendCommunicationStrategy extends BaseSendToPortalPopupStrategy {
    public readonly disclaimer = "";
    public readonly itemCheckOperation: number = LocalPatientOperations.History.OnPortalCommunicationMessageChecked;

    constructor() {
        super(
            PortalLinkedItemType.CommunicationHistory,
            LocalPatientOperations.History.Communications_PortalStatusRevoke,
            LocalPatientOperations.History.Communications_onCloseSendToPortalPopupClick
        );
    }

    public onSendToPortalClick(newMessage: string = null): void {
        sessionStore.dispatch(
            LocalPatientOperations.History.Communications_onSendToPortalClick,
            {
                messageText: newMessage
            }
        );
    }
}

export { SendCommunicationStrategy };
